export default __webpack_public_path__ + "media/images/transform_move-f73040ab8021f145031086e564861bf4.png";